<template>
    <v-container>
        <v-row
            class="mt-7"
            justify="center"
            no-gutters
        >
            <v-col
                cols="12"
            >  
                <!--        Username        -->
                <v-row
                    no-gutters
                >  
                    <v-text-field
                        v-model="accountInfo.email"
                        label="Email"
                        outlined
                        hide-details
                        class="px-5 mb-0 py-0"
                        disabled
                    />
                </v-row>
                <v-row
                    v-if="accountInfo.account_type != null"
                    no-gutters
                >
                    <v-text-field
                        v-model="accountInfo.account_type"
                        label="Account Type"
                        outlined
                        hide-details
                        class="px-5 mt-5 mb-0 py-0"
                        disabled
                    />
                </v-row>

                <v-row
                    v-if="!changePassword"
                    class="mt-5 mr-5"
                    justify="end"
                    no-gutters
                >
                    <v-btn
                        color="info"
                        @click.prevent="openChangePassword"
                    >
                        Change Password
                    </v-btn>
                </v-row>

                <!--      Old Password      -->
                <v-row
                    v-if="changePassword"
                    no-gutters
                >
                    <v-text-field
                        v-model="password"
                        label="Current Password"
                        outlined
                        hide-details
                        class="px-5 mt-5 mb-0 py-0"
                        type="password"
                        @keydown.enter="updatePassword"
                    />
                </v-row>
                
                <!--        Password        -->
                <v-card
                    v-if="changePassword"
                    outlined
                    class="mx-5 mt-5 pb-5"
                >
                    <v-row
                        no-gutters
                    >
                        <v-text-field
                            v-model="password1"
                            label="New Password"
                            outlined
                            hide-details
                            type="password"
                            class="px-5 mt-5 mb-0 py-0"
                            @keydown.enter="updatePassword"
                        />
                    </v-row>
                    <v-row
                        no-gutters
                    >
                        <v-text-field
                            v-model="password2"
                            label="New Password"
                            outlined
                            hide-details
                            type="password"
                            class="px-5 mt-5 mb-0 py-0"
                            @keydown.enter="updatePassword"
                        />
                    </v-row>
                </v-card>

                <!--    Confirmation Code   -->
                <v-row
                    v-if="changePassword"
                    no-gutters
                    class="mt-5"
                >
                    <v-col
                        class="text-left ml-5 mb-0 pa-0"
                    >
                        <v-btn
                            color="error"
                            @click.prevent="cancelChangePassword"
                        >
                            Cancel
                        </v-btn>
                    </v-col>
                    <v-col
                        class="text-right mr-5 mb-0 pa-0"
                    >
                        <v-btn
                            color="info"
                            @click.prevent="updatePassword"
                            :disabled="disableUpdate"
                        >
                            Update
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    no-gutters
                >
                    <v-col
                        class="text-right mt-1 pt-0 mx-5 red--text caption"
                    >
                        <v-row no-gutters>
                            <v-col
                                class="text-right ma-0 pa-0"
                            >
                                {{errorMessage1}}
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col
                                class="text-right ma-0 pa-0"
                            >
                                {{errorMessage2}}
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col
                                class="text-right ma-0 pa-0 green--text"
                            >
                                {{changePasswordMessage}}
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { Auth } from 'aws-amplify'

    export default {
        data: () => ({
            password: null,
            password1: null,
            password2: null,
            errorMessage1: null,
            errorMessage2: null,
            changePassword: false,
            changePasswordMessage: null,
        }),

        methods: {
            updatePassword() {
                this.errorMessage1 = null;
                this.errorMessage2 = null;
                this.changePasswordMessage = null;

                if (this.password1 != this.password2) {
                    this.errorMessage1 = "Passwords do not match"
                }
                
                if (this.password1.length < 6 | this.password2.length < 6) {
                    this.errorMessage2 = "Password must be at least 6 characters"
                }

                if (this.errorMessage1 == null && this.errorMessage2 == null) {
                    Auth.currentAuthenticatedUser(this.accountInfo.email, this.password, this.password1)
                    .then(
                        data => {
                            console.log(data);
                            this.errorMessage1 = null;
                            this.errorMessage2 = null;
                            this.changePassword = false;
                            this.password = null;
                            this.password1 = null;
                            this.password2 = null;
                            this.changePasswordMessage = 'Password successfully updated';
                    }).catch(
                        error => {
                            console.log(error);
                            this.errorMessage2 = error;
                        }
                    );
                }
            },

            openChangePassword() {
                this.changePassword = true;
                // console.log('accountInfo:',this.accountInfo);
                // console.log('authenticatedUser:',this.user);
                
            },

            cancelChangePassword() {
                this.changePassword = false;
                this.password = null;
                this.password1 = null;
                this.password2 = null;
            },

        },

        computed: {
            disableUpdate() {
                if(this.password == null | this.password == '' | this.password1 == null | this.password1 == '' | this.password2 == null | this.password2 == '') {
                    return true
                } else {
                    return false
                }
            },

            accountInfo() {
                return this.$store.getters['data/account'];
            },
                
        }

    }
</script>

<style scoped>
  a {
    color: blue !important;
    text-decoration: underline;
  }
</style>